const PRODUCTION_EXTENSION_ID = 'fbgdjpgcehknbpaoigchadbjfibmpife';
const STAGING_EXTENSION_ID = 'nfpjlapgemcaphchamepnoijgeapjboa';

const isProductionHost = () => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname.toLowerCase();
  return hostname === 'traffic-lite-production.netlify.app' || hostname === 'traffic-lite.netlify.app';
};

export const getExtensionId = (): string => {
  if (isProductionHost()) {
    return PRODUCTION_EXTENSION_ID;
  }

  const nonProdExtensionId = (import.meta.env.VITE_NON_PROD_EXTENSION_ID || '').trim();
  return nonProdExtensionId || STAGING_EXTENSION_ID;
};

export const getProductionExtensionId = (): string => PRODUCTION_EXTENSION_ID;
